import React from "react";
import { useParams } from "react-router-dom";

const DailyReportScreen = () => {
    let { dailyReportId } = useParams();
    return <h1>Daily Report: {dailyReportId}</h1>;
};

export default DailyReportScreen;
